export default "__VITE_ASSET__DbYoUMQN__"